import _ from 'lodash';
import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators, UntypedFormArray } from '@angular/forms';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { CampaignService } from '../../services/campaign.service';
import { Subject } from 'rxjs';

import * as DialogActions from 'app/dialog/features/dialog.actions';
import { Store } from '@ngrx/store';
import { DialogService } from 'app/dialog/services/dialog.service';
import { filter, takeUntil } from 'rxjs/operators';
import { MerchandiseFormSchema } from 'app/campaign/structure/merchandise';

@Component({
  selector: 'app-campaign-form-field-list',
  templateUrl: './campaign-form-field-list.component.html',
  styleUrls: ['./campaign-form-field-list.component.scss']
})
export class CampaignFormFieldListComponent implements OnInit, OnDestroy {

  @Input() presetOption: any = null;

  public types = [{
    id: 1,
    label: 'Text'
  }, {
    id: 2,
    label: 'Selection - to be selection from options'
  }, {
    id: 3,
    label: 'Street Address'
  }, {
    id: 4,
    label: 'Phone Number'
  }];

  public option: UntypedFormGroup = null;
  public options: UntypedFormArray = null;
  public optionsControl: UntypedFormControl = null;

  public takeUntilSubject: Subject<any> = new Subject()

  constructor(
    public store: Store,
    public formBuilder: UntypedFormBuilder,
    public campaignService: CampaignService,
    public dialogService: DialogService,
    public cdr: ChangeDetectorRef
  ) {
    this.option = this.formBuilder.group({});
    this.campaignService.generateForm(this.option, MerchandiseFormSchema);
  }

  ngOnInit(): void {
    this.options = this.presetOption.get('shoppingForm');
    this.optionsControl = this.option.get('options') as UntypedFormControl;
    this.reNgOnInit()
  }

  ngOnChanges(changes){
    const presetOption = _.get(changes, 'presetOption.currentValue', this.presetOption);
    if(presetOption){
      this.reNgOnInit()
    }
  }

  reNgOnInit() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
    
    this.takeUntilSubject = new Subject();
    this.options = this.presetOption.get('shoppingForm');
    this.optionsControl = this.option.get('options') as UntypedFormControl;

    this.campaignService.configGroup(this.option, this.option, {
      name: 'type',
      value: 2
    }, [
      { name: 'options', defaultValue: [], validators: [Validators.required] }
    ], this.takeUntilSubject);

    this.dialogService.closeDialogSubject.pipe(
      filter(data => _.get(data, 'name', null) === 'formField'),
      filter(data => _.get(data, 'action', null) === 'add'),
      filter(data => _.get(data, 'value', false)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(data => {
      const group = new UntypedFormGroup({});
      this.campaignService.generateForm(group, MerchandiseFormSchema);
      this.campaignService.initializeForm(group, data.value, MerchandiseFormSchema);
      this.options.push(group);
      this.cdr.markForCheck();
    });

    this.dialogService.closeDialogSubject.pipe(
      filter(data => _.get(data, 'name', null) === 'formField'),
      filter(data => _.get(data, 'action', null) === 'edit'),
      takeUntil(this.takeUntilSubject)
    ).subscribe(data => {
      const value = _.get(data, 'value', null);
      if(value) {
        this.campaignService.initializeForm(this.options.controls[data.id] as UntypedFormGroup, value, MerchandiseFormSchema);
        this.cdr.markForCheck();
      }
    });
  }

  ngOnDestroy() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

  addFormField(initialState = {
    id: null,
    action: 'add'
  }) {
    const action = DialogActions.openDialog({
      payload: {
        name: "formField",
        options: {
          size: 'default',
          modalClass:'modal--paybee',
          containerClass:'mdb-modal-backdrop-paybee',
          ignoreBackdropClick: true
        },
        initialState
      }
    });
    this.store.dispatch(action);
  }

  editFormField(option, index) {
    const action = DialogActions.openDialog({
      payload: {
        name: "formField",
        options: {
          size: 'default',
          modalClass:'modal--paybee',
          containerClass:'mdb-modal-backdrop-paybee',
          ignoreBackdropClick: true
        },
        initialState: {
          id: index,
          action: 'edit',
          option
        }
      }
    });
    this.store.dispatch(action);
  }

  registerFormField() {
    const { option } = this;
    if(option.invalid) {
      option.markAllAsTouched();
      return false;
    }

    const group = new UntypedFormGroup({});
    this.campaignService.generateForm(group, MerchandiseFormSchema);
    this.campaignService.initializeForm(group, option.value, MerchandiseFormSchema);
    this.options.push(group);

    option.reset();
  }

  dropOption(event) {
    moveItemInArray(this.options.controls, event.previousIndex, event.currentIndex);
  }

  removeOption(index) {
    this.options.removeAt(index);
  }

}
